import React from 'react';
import PropTypes from "prop-types";
import {useFormik} from "formik";

import {ResponsiveDialog} from "../../../../../components/ResponsiveDialog";
import depositValidationSchema from "./validator";

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField/TextField";
import InputAdornment from "@mui/material/InputAdornment";


const FormEditDeposit= (props) => {
    const {booking, isLoading, onSubmit, onClose} = props;

    const formik = useFormik({
        initialValues: {
            deposit: booking.bookingFinance.deposit ?? null,
        },
        validationSchema: depositValidationSchema,
        onSubmit: values => {
            onSubmit({bookingFinanceAttributes: {
                id: booking.bookingFinance.id,
                deposit: values.deposit
            }});
        }
    });

    const submitIsEnabled = !Object.keys(formik.errors).some(x => formik.touched[x]);

    return (
        <ResponsiveDialog title={"Modifica caparra"}
                          isOpen={true}
                          maxWidth="md"
                          scroll="paper"
                          isLoading={isLoading}
                          showApply={true}
                          applyLabel="Salva"
                          enableApply={submitIsEnabled}
                          onApply={formik.handleSubmit}
                          closeLabel="Cancella"
                          onClose={onClose}>

            <Grid container spacing={3} sx={{mt: 2}}>
                <Grid item xs={12}>
                    <TextField type="number"
                               label="Caparra concordata"
                               fullWidth
                               name="deposit"
                               value={formik.values.deposit ?? ''}
                               onChange={formik.handleChange}
                               error={formik.touched.deposit && Boolean(formik.errors.deposit)}
                               helperText={formik.touched.deposit && formik.errors.deposit}
                               InputProps={{
                                   startAdornment: <InputAdornment position="start">€</InputAdornment>,
                               }}/>
                </Grid>
            </Grid>

        </ResponsiveDialog>
    );
};

FormEditDeposit.propTypes = {
    booking: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
}

export default FormEditDeposit;